import React, { Suspense, useState } from 'react'
import SimpleBar from 'simplebar-react'
import { CSSTransition } from 'react-transition-group'
import { Nav, Button, Navbar } from '@themesberg/react-bootstrap'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons'

import { getItem } from '../../utils/storageUtils'
const SuperAdminNavItems = React.lazy(() => import('./components/SuperAdminNavItems'))
// const TenantNavItems = React.lazy(() => import('./components/TenantNavItems'))

export default (props = {}) => {
  const [show, setShow] = useState(false)
  const showClass = show ? 'show' : ''

  let { role, adminRole, tenantAdminRole } = useSelector((state) => state.login)
  const { adminRoleId, superAdminUser, adminDetails } = useSelector(state => state.admins)

  if (!role) {
    role = getItem('role')
  }

  const roleData =
    adminRole
      ? adminRole?.find(val => val.superRoleId !== 1 && val.superRoleId === parseInt(adminRoleId))?.name
      : tenantAdminRole?.find(val => val.adminRoleId !== 1 && val.adminRoleId === parseInt(superAdminUser?.adminRoleId))?.name

  const onCollapse = () => setShow(!show)

  return (
    <>
      <Navbar
        expand={false}
        collapseOnSelect
        variant='dark'
        className='navbar-theme-primary px-4 d-md-none'
      >
        <Navbar.Toggle
          as={Button}
          aria-controls='main-navbar'
          onClick={onCollapse}
        >
          <span className='navbar-toggler-icon' />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames='sidebar-transition'>
        <SimpleBar
          className={`collapse ${showClass} sidebar d-md-block text-white pb-4`}
        >
          <div className='sidebar-inner px-3 pt-3 pb-2'>

            <Nav className='flex-column pt-3 pt-md-0'>
              <div className='avatar-wrap'>
                <div className='avatar-box'>
                  <img src='/avatar-img.png' className='img-fluid' alt='Avatar' />
                </div>
              </div>
              <h5 className='d-flex align-items-center m-auto mb-0'>{role}&nbsp;
                {roleData && <span style={{ fontSize: '15px' }}>({roleData})</span>}
              </h5>
              {(superAdminUser?.email || adminDetails?.email) && <span style={{ fontSize: '15px', textAlign: 'center' }}>{superAdminUser?.email || adminDetails?.email}</span>}

              <Button variant='btn btn-primary btn-sm d-none' className='logout-btn'>
                <FontAwesomeIcon icon={faSignOutAlt} />
                <span className='ms-2'>Logout</span>
              </Button>

              <hr />

              <Suspense fallback={null}>
                <SuperAdminNavItems setShow={setShow} />
              </Suspense>

              {/* {role === 'Admin' &&
                <Suspense fallback={null}>
                  <TenantNavItems setShow={setShow} />
                </Suspense>} */}
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  )
}
